import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Text,
  Box,
  Divider,
} from '@chakra-ui/core';

export default function InfoHoraire(props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const opening_hours =
    props.post &&
    Object.keys(props.post.opening_hours).map(key => [
      key,
      props.post.opening_hours[key],
    ]);

  var days = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];
  var d = new Date();
  var dayName = days[d.getDay()];
  return (
    <>
      <Button
        mb="4"
        rounded="20px"
        _hover={{ bg: 'red.700' }}
        bg="red.500"
        color="white"
        ref={btnRef}
        onClick={onOpen}
      >
        Infos et horaires
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        size="md"
        finalFocusRef={btnRef}
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Infos et horaires</DrawerHeader>

            <DrawerBody>
              <Text fontSize="xl" m="4">
                <span style={{ fontWeight: 'bold' }}>Adress de retrait:</span>{' '}
                {props.post && props.post.adress}
              </Text>
              <Divider mb=""></Divider>
              <Box color="black" rounded="20px" p="20px" bg="gray.200">
                {opening_hours &&
                  opening_hours.map(res => {
                    return (
                      <Box mb="4">
                        <Text
                          fontSize="xl"
                          color={res[0] === dayName && 'red.300'}
                          m="4"
                          d="inline"
                          fontWeight="bold"
                        >
                          {res[0]} :{' '}
                          {res[1].map(hours => (
                            <Text fontSize="xl" d="inline" fontWeight="normal">
                              {'('}
                              {hours}
                              {')'}{' '}
                            </Text>
                          ))}
                        </Text>
                      </Box>
                    );
                  })}
              </Box>
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
}
